import React, {useEffect, useState} from 'react';
import axios from '../../../AxiosInstance';
import styles from './login.module.css';
import {PrimaryButton, TextInput} from "../../../components/input/inputs";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";

export default function Login() {
    const {t} = useTranslation();
    const [form, setForm] = useState({});
    const [showError, setShowError] = useState(false);
    const [doLogin, setDoLogin] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        setShowError(false);
    }, [form])

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            setDoLogin(true);
        }
    }

    useEffect(() => {
        if (doLogin) {
            handleSubmit();
        }
    }, [doLogin]);

    useEffect(() => {
        // Add a global event listener for keydown
        window.addEventListener('keydown', handleKeyPress);

        // Clean up the event listener when the component unmounts
        return () => {
            window.removeEventListener('keydown', handleKeyPress);
        };
    }, []);

    const checkOnboardingStatus = async (token) => {
        try {
            const response = await axios.get("onboarding/status/", {
                headers: { Authorization: `Bearer ${token}` }
            });

            if (response.data.needs_onboarding) {
                window.location.replace('/onboarding');
            } else {
                window.location.replace('/');
            }
        } catch (err) {
            // If onboarding check fails, proceed to dashboard
            window.location.replace('/');
        }
    };

    const handleSubmit = (event) => {
        axios.post("login/", {
            username: form.username,
            password: form.password,
        }).then((response) => {
            setShowError(false);
            localStorage.clear();
            localStorage.setItem('access_token', response.data.access);
            localStorage.setItem('refresh_token', response.data.refresh);
            axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.access}`;
            checkOnboardingStatus(response.data.access);
        }).catch((err) => {
            setShowError(true);
        })
    };

    const forgotPassword = () => {
        navigate('/forgot');
    }

    return (
        <div className={styles.container}>

            <div className={styles.background}>
                <img alt={'background'} src={'/login.png'} width={'100%'}/>
            </div>

            <div className={`${styles.loginContainer} px-4 pt-4`}>
                <div className={styles.innerContainer}>
                    <div className={'pt-4 pb-4'}>
                        <img alt={'myindustrialdata'} src={'/logo_hd.svg'} width={'100%'}/>
                    </div>

                    {showError &&
                        <div className={`${styles.error} px-3`}>
                            <img alt={'alert'} src={'/alert.png'} height={'24px'}/>
                            <div>{t('auth.login.error')}</div>
                        </div>
                    }

                    <div className={'mt-3'}>
                        <TextInput email={true} name={'username'} form={form} setForm={setForm} placeholder={t('auth.login.username')} hideName={true}/>
                        <TextInput name={'password'} form={form} setForm={setForm} placeholder={t('auth.login.password')} hideName={true} password={true}/>
                    </div>

                    <div className={`${styles.forgot} mb-4`} onClick={forgotPassword} role={'button'}>{t('auth.login.forgotPassword')}</div>

                    <div className={'mb-3'}>
                        <PrimaryButton name={t('auth.login.button')} onClick={handleSubmit}/>
                    </div>
                </div>
            </div>
        </div>
    )
}
